<template>
  <div class="sb-toggle" :class="toggleOnColor">
    <span v-if='toggleOnText && isChecked'>{{ toggleOnText }} &nbsp;&nbsp;</span>
    <span v-if='toggleOffText && !isChecked'>&nbsp;{{ toggleOffText }} &nbsp;&nbsp;</span>
    <label class="switch">
      <input @click="clickedCheckbox($event.target.checked)" v-model="isChecked" type="checkbox" checked :disabled="!isEnabled">
      <span class="slider round"></span>
    </label>
  </div>
</template>

<script>
export default {
  name: 'Toggle',
  props: {
    isEnabled: {
      type: Boolean,
      default: true
    },
    checked: {                           // can be used on parent component with sync - :checked.sync="myLocalValue"
      type: Boolean,
      default: false
    },
    toggleOnText: {
      type: String,
      default: ''
    },
    toggleOffText: {
      type: String,
      default: ''
    },
    toggleOnColor: {
      type: String,
      default: ''
    }
  },
  computed: {
    isChecked: {
      get () {
        return this.checked
      },
      set (c) {
        this.$emit('update:checked', c)
      }
    }
  },
  methods: {
    clickedCheckbox (c) {                 // can also capture the actual click event on parent - @clicked="handleClickEvent"
      this.$emit('clicked', c)            // the input box value is also passed as an argument - type: Boolean
    }
  }
}
</script>

<style scoped lang="scss">
.sb-toggle {
  display: flex;
  align-items: center;
}
.switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 20px;
  margin-bottom: 0;
}

.switch input {display:none;}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #E2E3E5;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 14px;
  width: 14px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #31991E;
}

input:focus + .slider {
  box-shadow: 0 0 1px #31991E;
}

.sb-toggle.primary {
  input:checked + .slider {
    background-color: #2470AF;
  }
  input:focus + .slider {
    box-shadow: 0 0 1px #2470AF;
  }
}

input:checked + .slider:before {
  -webkit-transform: translateX(20px);
  -ms-transform: translateX(20px);
  transform: translateX(20px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 20px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>
